import React, { useEffect, useState } from "react";
import Pagination from "react-js-pagination";
import ConfigDB from "../../config";
import { toast } from "react-toastify";
import Utils from "../../utils";
import {
  Button,
  Form,
  FormGroup,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import { useLocation, useNavigate } from "react-router-dom";
import Dropdown from "react-bootstrap/Dropdown";
import { useTranslation } from "react-i18next";
import ReactPaginate from "react-paginate";
import {
  createTax,
  deleteTax,
  getAllTaxSync,
  getTaxList,
  getTimeZoneList,
  updateTax,
} from "../../services/MoloniServices";
import Select from "react-select";

const TaxMoloni = () => {
  const tableLengthList = ConfigDB.data.dataTableLength;
  const data = localStorage.getItem(ConfigDB.data.login_data);
  const companyId = JSON.parse(data);
  const navigate = useNavigate();

  const location = useLocation();
  const [activeTab, setActiveTab] = useState("tpsoft");

  const [params, setParams] = useState({
    limit: tableLengthList[0],
    page: 1,
    search: "",
    is_reload: false,
    company_id: "269134",
    created_from: activeTab === "tpsoft" ? 1 : 2,
  });
  const { t } = useTranslation();

  const [totalRecords, setTotalRecords] = useState(0);
  const [taxMoloniList, setTaxMoloniList] = useState([]);
  const [delModal, setDelModal] = useState(false);
  const [isDelButtonLoad, setIsDelButtonLoad] = useState(false);
  const [delType, setDelType] = useState("");
  const [modifyModal, setModifyModal] = useState(false);
  const [isModifyButtonLoad, setIsModifyButtonLoad] = useState(false);
  const [taxMoloniData, setTaxMoloniData] = useState({
    id: "",
    name: "",
    value: "",
    type: "",
    saft_type: "",
    vat_type: "",
    stamp_tax: "",
    exemption_reason: "",
    fiscal_zone: "",
    active_by_default: 0,
    moloni_id: "",
  });

  let errorsObj = {
    name: "",
    value: "",
    type: "",
    saft_type: "",
    vat_type: "",
    stamp_tax: "",
    exemption_reason: "",
    fiscal_zone: "",
  };
  const [errors, setErrors] = useState(errorsObj);
  const [timeZoneList, setTimeZoneList] = useState([]);
  const [isTaxLoading, setIsTaxLoading] = useState(false);

  const handleTabChange = (tab) => {
    setActiveTab(tab);

    setParams((prevParams) => ({
      ...prevParams,
      created_from: tab === "tpsoft" ? 1 : 2,
    }));
  };

  const handleAddModal = () => {
    setModifyModal(true);
  };

  const handleCloseModal = () => {
    setModifyModal(false);
    setTaxMoloniData({
      id: "",
      name: "",
      value: "",
      type: "",
      saft_type: "",
      vat_type: "",
      stamp_tax: "",
      exemption_reason: "",
      fiscal_zone: "",
      active_by_default: 0,
      moloni_id: "",
    });

    setErrors("");
  };

  useEffect(() => {
    const currentPath = location.pathname;
    const savedPath = localStorage.getItem("lastVisitedPath");

    if (savedPath && savedPath !== currentPath) {
      localStorage.removeItem("lastVisitedPage");
      localStorage.removeItem("searchValue");
    }

    localStorage.setItem("lastVisitedPath", currentPath);

    const savedPage = localStorage.getItem("lastVisitedPage");
    const storedSearch = localStorage.getItem("searchValue") || "";

    setParams((prevParams) => ({
      ...prevParams,
      search: storedSearch,
      page: savedPage ? parseInt(savedPage, 10) : 1,
    }));
  }, [location.pathname]);

  const handleParams = (e, type) => {
    let paramsObj = { ...params };
    if (type === "length") {
      paramsObj.limit = e.target.value;
    } else if (type === "search") {
      paramsObj.page = 1;
      paramsObj.search = e.target.value;
      localStorage.setItem("searchValue", e.target.value);
      localStorage.removeItem("lastVisitedPage");
    } else if (type === "pagination") {
      paramsObj.page = e.selected + 1;
      localStorage.setItem("lastVisitedPage", e.selected + 1);
    }
    setParams(paramsObj);
  };

  const handleCheckboxDefaultChange = (e) => {
    setTaxMoloniData({
      ...taxMoloniData,
      active_by_default: e.target.checked ? 1 : 0,
    });
  };

  const fetchTaxMoloni = () => {
    let data = { ...params };
    getTaxList(data)
      .then((response) => {
        setTaxMoloniList(response.data.data);
        setTotalRecords(response.data.total);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      });
  };

  useEffect(
    function () {
      let data = { ...params };

      fetchTaxMoloni(data);
    },
    [params],
  );

  const handleTaxSync = () => {
    setIsTaxLoading(true);

    let data = { company_id: "269134" };
    getAllTaxSync(data)
      .then((response) => {
        toast.success(response.data.message);

        let data = { ...params };
        getTaxList(data)
          .then((response) => {
            setTaxMoloniList(response.data.data);
            setTotalRecords(response.data.total);
          })
          .catch((err) => {
            toast.error(Utils.getErrorMessage(err));
          })
          .finally(() => {
            setIsTaxLoading(false);
          });
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
        setIsTaxLoading(false);
      });
  };

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
    };
    getTimeZoneList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].code,
            label: response.data[i].code,
          });
        }

        setTimeZoneList(list);
      })
      .catch((err) => {});
  }, []);

  const onDeleteModalClose = () => {
    setDelModal(false);
  };

  const onDeleteModalOpen = (e, item) => {
    e.preventDefault();
    setDelType(item.moloni_id);
    setDelModal(true);
  };

  const onDestroyBank = (e) => {
    e.preventDefault();
    setIsDelButtonLoad(true);
    let data = { tax_id: delType, company_id: "269134" };
    deleteTax(data)
      .then((response) => {
        let data = { ...params };

        fetchTaxMoloni(data);
        toast.success(response.data.message);
        setDelType("");
        setDelModal(false);
        setIsDelButtonLoad(false);
      })
      .catch((err) => {
        setIsDelButtonLoad(false);
        toast.error(Utils.getErrorMessage(err));
      });
  };

  const handleSubmitForm = (e) => {
    e.preventDefault();
    let error = false;
    let errorObj = { ...errorsObj };
    if (!taxMoloniData.name) {
      errorObj.name = `Name is required.`;
      error = true;
    }

    if (!taxMoloniData.value) {
      errorObj.value = `Value is required.`;
      error = true;
    }

    if (!taxMoloniData.type) {
      errorObj.type = `Type is required.`;
      error = true;
    }

    if (!taxMoloniData.saft_type) {
      errorObj.saft_type = `Saft type is required.`;
      error = true;
    }

    if (taxMoloniData?.saft_type === 1) {
      if (!taxMoloniData.vat_type) {
        errorObj.vat_type = `Vat type is required.`;
        error = true;
      }
    }

    if (taxMoloniData?.saft_type === 2) {
      if (!taxMoloniData.stamp_tax) {
        errorObj.stamp_tax = `Stamp tax code is required.`;
        error = true;
      }
    }

    if (!taxMoloniData.fiscal_zone) {
      errorObj.fiscal_zone = `Fiscal zone is required.`;
      error = true;
    }

    if (!taxMoloniData.exemption_reason) {
      errorObj.exemption_reason = `Exemption reason is required.`;
      error = true;
    }

    setErrors(errorObj);
    Utils.focusError();

    if (error) return;

    setIsModifyButtonLoad(true);

    let data = {
      company_id: "269134",
      name: taxMoloniData?.name,
      value: taxMoloniData?.value,
      type: taxMoloniData?.type,
      saft_type: taxMoloniData?.saft_type,
      vat_type: taxMoloniData?.saft_type === 1 ? taxMoloniData?.vat_type : "",
      stamp_tax: taxMoloniData?.saft_type === 2 ? taxMoloniData?.stamp_tax : "",
      exemption_reason: taxMoloniData?.exemption_reason,
      fiscal_zone: taxMoloniData?.fiscal_zone,
      active_by_default: taxMoloniData?.active_by_default,
    };

    let updateData = {
      company_id: "269134",
      id: taxMoloniData?.id,
      name: taxMoloniData?.name,
      value: taxMoloniData?.value,
      type: taxMoloniData?.type,
      saft_type: taxMoloniData?.saft_type,
      vat_type: taxMoloniData?.saft_type === 1 ? taxMoloniData?.vat_type : "",
      stamp_tax: taxMoloniData?.saft_type === 2 ? taxMoloniData?.stamp_tax : "",
      exemption_reason: taxMoloniData?.exemption_reason,
      fiscal_zone: taxMoloniData?.fiscal_zone,
      active_by_default: taxMoloniData?.active_by_default,
      tax_id: taxMoloniData?.moloni_id,
    };

    if (taxMoloniData?.id) {
      updateTax(updateData)
        .then((response) => {
          toast.success(response.data.message);
          let data = { ...params };
          fetchTaxMoloni(data);
          setModifyModal(false);
          setIsModifyButtonLoad(false);
          setTaxMoloniData({
            id: "",
            name: "",
            value: "",
            type: "",
            saft_type: "",
            vat_type: "",
            stamp_tax: "",
            exemption_reason: "",
            fiscal_zone: "",
            active_by_default: 0,
            moloni_id: "",
          });
        })
        .catch((err) => {
          toast.error(Utils.getErrorMessage(err));
          setIsModifyButtonLoad(false);
        });
    } else {
      createTax(data)
        .then((response) => {
          toast.success(response.data.message);
          let data = { ...params };
          fetchTaxMoloni(data);
          setModifyModal(false);
          setIsModifyButtonLoad(false);
          setTaxMoloniData({
            id: "",
            name: "",
            value: "",
            type: "",
            saft_type: "",
            vat_type: "",
            stamp_tax: "",
            exemption_reason: "",
            fiscal_zone: "",
            active_by_default: 0,
            moloni_id: "",
          });
        })
        .catch((err) => {
          toast.error(Utils.getErrorMessage(err));
          setIsModifyButtonLoad(false);
        });
    }
  };

  return (
    <div>
      <div>
        <section className="content-header">
          <div className="container-fluid container-custom-height-new">
            <div className="row mb-2">
              <div className="col-sm-12 d-flex align-items-center">
                <button
                  type="button"
                  className="next-button btn btn-secondary"
                  onClick={() => navigate("/moloni-settings")}
                >
                  <i className="bi bi-arrow-left"></i> {t("back")}
                </button>
                <h1 className="page-title ms-auto mb-2">{t("taxAndFees")}</h1>
              </div>
            </div>
          </div>
        </section>

        <section className="content">
          <div className="container-fluid container-custom-height-new">
            <div className="row">
              <div className="col-md-12">
                <div className="card fuelCard">
                  <div className="card-header">
                    <div
                      className="card-title m-0 float-left"
                      style={{ width: "50%" }}
                    >
                      <input
                        type="text"
                        className="form-control input-search"
                        value={params.search}
                        onChange={(e) => handleParams(e, "search")}
                        placeholder="Search"
                      ></input>
                    </div>

                    <div className="card-title m-0 float-right d-flex">
                      <button
                        type="button"
                        className="btn  btn-icon-text mr-2"
                        onClick={() => navigate("/add-tax-fees")}
                      >
                        <i className="bi bi-plus-lg"></i>
                        <span className="ms-2">{t("Add")}</span>
                      </button>

                      {activeTab === "moloni" && (
                        <button
                          type="button"
                          className="btn mr-2"
 style={{
                            background: "#81bb42",
                            width: "52px",
                            height: "36px",
                          }}                          onClick={handleTaxSync}
                          disabled={isTaxLoading}
                        >
                          {isTaxLoading ? (
                            <span
                              className="spinner-border spinner-border-sm"
                              role="status"
                              aria-hidden="true"
                            ></span>
                          ) : (
                            <i className="bi bi-arrow-repeat"></i>
                          )}
                        </button>
                      )}
                    </div>
                  </div>
                  <div className="card-body fuelCardB">
                    <div className="tabs-section">
                      <ul className="nav nav-tabs">
                        <li className="nav-item">
                          <a
                            className={`nav-link ${
                              activeTab === "tpsoft" ? "active" : ""
                            }`}
                            onClick={() => handleTabChange("tpsoft")}
                            style={{ cursor: "pointer" }}
                          >
                            TPSoft
                          </a>
                        </li>

                        <li className="nav-item">
                          <a
                            className={`nav-link ${
                              activeTab === "moloni" ? "active" : ""
                            }`}
                            onClick={() => handleTabChange("moloni")}
                            style={{ cursor: "pointer" }}
                          >
                            Moloni
                          </a>
                        </li>
                      </ul>

                      <div className="tab-content">
                        <div
                          className={`tab-pane fade ${
                            activeTab === "tpsoft" ? "show active" : ""
                          }`}
                        >
                          <div
                            className="vehicleThBg table-responsive  table-responsive-vehicle"
                            style={{ marginTop: "15px" }}
                          >
                            <table className="table table-bordered">
                              <thead>
                                <tr>
                                  <th
                                    className="col-form-label ml-2 Label-my form-label form-label"
                                    style={{ width: "10%" }}
                                  >
                                    {t("name")}
                                  </th>

                                  <th
                                    className="col-form-label ml-2 Label-my form-label form-label"
                                    style={{ width: "10%" }}
                                  >
                                    {t("value")}
                                  </th>

                                  <th
                                    className="col-form-label ml-2 Label-my form-label form-label"
                                    style={{ width: "10%" }}
                                  >
                                    {t("type")}
                                  </th>

                                  <th
                                    className="col-form-label ml-2 Label-my form-label form-label"
                                    style={{ width: "10%" }}
                                  >
                                    {t("safetype")}
                                  </th>
                                  <th
                                    className="col-form-label ml-2 Label-my form-label form-label"
                                    style={{ width: "10%" }}
                                  >
                                    {t("stamptaxcode")}
                                  </th>
                                  <th
                                    className="col-form-label ml-2 Label-my form-label form-label"
                                    style={{ width: "10%" }}
                                  >
                                    {t("exemptionReason")}
                                  </th>
                                  <th
                                    className="col-form-label ml-2 Label-my form-label form-label"
                                    style={{ width: "10%" }}
                                  >
                                    {t("fiscalZone")}
                                  </th>
                                  <th
                                    className="col-form-label ml-2 Label-my form-label form-label"
                                    style={{ width: "10%" }}
                                  >
                                    {t("activeByDefualt")}
                                  </th>
                                  <th
                                    className="col-form-label ml-2 Label-my form-label form-label"
                                    style={{ width: "10%" }}
                                  >
                                    {t("vatType")}
                                  </th>

                                  <th
                                    className="col-form-label ml-2 Label-my form-label form-label"
                                    style={{ width: "0%" }}
                                  >
                                    {t("action")}
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {taxMoloniList?.map((item, index) => {
                                  return (
                                    <>
                                      <tr>
                                        <td>{item.name}</td>
                                        <td>{item.value}</td>
                                        <td>
                                          {item.type === 1
                                            ? "Percentage (Ex: VAT)"
                                            : item.type === 2
                                              ? "Fixed Value"
                                              : item.type === 3
                                                ? "Item Based"
                                                : ""}
                                        </td>
                                        <td>
                                          {item.safe_type === 1
                                            ? "VAT"
                                            : item.safe_type === 2
                                              ? "Stamp Duty"
                                              : item.safe_type === 3
                                                ? "Other"
                                                : ""}
                                        </td>
                                        <td>{item.stamp_tax || "-"}</td>
                                        <td>{item.exemption_reason}</td>
                                        <td>{item.fiscal_zone}</td>
                                        <td>
                                          {item.active_by_default === 1
                                            ? "Yes"
                                            : "No"}
                                        </td>

                                        <td>{item.vat_type || "-"}</td>
                                        <td className="d-flex">
                                          <Dropdown
                                            className="iconDropdown"
                                            onToggle={(isOpen) => {
                                              if (isOpen) {
                                                // This logic runs when the dropdown is opened
                                                const tableResponsive =
                                                  document.querySelector(
                                                    ".table-responsive",
                                                  );
                                                if (window.innerWidth <= 767) {
                                                  if (tableResponsive) {
                                                    tableResponsive.style.overflowX =
                                                      "auto !important";
                                                    tableResponsive.style.overflowY =
                                                      "auto !important";
                                                  }
                                                } else {
                                                  if (tableResponsive) {
                                                    tableResponsive.style.overflowX =
                                                      "inherit !important";
                                                    tableResponsive.style.overflowY =
                                                      "inherit !important";
                                                  }
                                                }
                                              }
                                            }}
                                          >
                                            <Dropdown.Toggle
                                              variant="success"
                                              id="dropdown-basic"
                                              className="iconToggle"
                                            >
                                              <i className="bi bi-three-dots-vertical"></i>
                                            </Dropdown.Toggle>

                                            <Dropdown.Menu>
                                              <Dropdown.Item
                                                href="#/action-1"
                                                className="d-flex"
                                                onClick={() =>
                                                  navigate(
                                                    `/update-tax-fees/${item.id}`,
                                                    {
                                                      state: item,
                                                    },
                                                  )
                                                }
                                              >
                                                <div className="edit-btn">
                                                  <i className="bi bi-pencil"></i>
                                                </div>
                                                <span>{t("edit")}</span>
                                              </Dropdown.Item>
                                              <Dropdown.Item
                                                href="#/action-2"
                                                className="d-flex"
                                                onClick={(e) =>
                                                  onDeleteModalOpen(e, item)
                                                }
                                              >
                                                <div className="trash-btn">
                                                  <a className="delete-btn">
                                                    <i className="bi bi-trash3"></i>
                                                  </a>
                                                </div>
                                                <span>{t("delete")}</span>
                                              </Dropdown.Item>
                                            </Dropdown.Menu>
                                          </Dropdown>
                                        </td>
                                      </tr>
                                    </>
                                  );
                                })}
                              </tbody>
                              {taxMoloniList && taxMoloniList?.length === 0 && (
                                <tr>
                                  <td colSpan={7} className={`text-center`}>
                                    {t("no_record_found")}
                                  </td>
                                </tr>
                              )}
                            </table>
                          </div>
                        </div>

                        <div
                          className={`tab-pane fade ${
                            activeTab === "moloni" ? "show active" : ""
                          }`}
                        >
                          <div
                            className="vehicleThBg table-responsive table-responsive1  table-responsive-vehicle"
                            style={{ marginTop: "15px" }}
                          >
                            <table className="table table-bordered">
                              <thead>
                                <tr>
                                  <th
                                    className="col-form-label ml-2 Label-my form-label form-label"
                                    style={{ width: "10%" }}
                                  >
                                    {t("name")}
                                  </th>

                                  <th
                                    className="col-form-label ml-2 Label-my form-label form-label"
                                    style={{ width: "10%" }}
                                  >
                                    {t("value")}
                                  </th>

                                  <th
                                    className="col-form-label ml-2 Label-my form-label form-label"
                                    style={{ width: "10%" }}
                                  >
                                    {t("type")}
                                  </th>

                                  <th
                                    className="col-form-label ml-2 Label-my form-label form-label"
                                    style={{ width: "10%" }}
                                  >
                                    {t("safetype")}
                                  </th>
                                  <th
                                    className="col-form-label ml-2 Label-my form-label form-label"
                                    style={{ width: "10%" }}
                                  >
                                    {t("stamptaxcode")}
                                  </th>
                                  <th
                                    className="col-form-label ml-2 Label-my form-label form-label"
                                    style={{ width: "10%" }}
                                  >
                                    {t("exemptionReason")}
                                  </th>
                                  <th
                                    className="col-form-label ml-2 Label-my form-label form-label"
                                    style={{ width: "10%" }}
                                  >
                                    {t("fiscalZone")}
                                  </th>
                                  <th
                                    className="col-form-label ml-2 Label-my form-label form-label"
                                    style={{ width: "10%" }}
                                  >
                                    {t("activeByDefualt")}
                                  </th>
                                  <th
                                    className="col-form-label ml-2 Label-my form-label form-label"
                                    style={{ width: "10%" }}
                                  >
                                    {t("vatType")}
                                  </th>

                                  <th
                                    className="col-form-label ml-2 Label-my form-label form-label"
                                    style={{ width: "0%" }}
                                  >
                                    {t("action")}
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {taxMoloniList?.map((item, index) => {
                                  return (
                                    <>
                                      <tr>
                                        <td>{item.name}</td>
                                        <td>{item.value}</td>
                                        <td>
                                          {item.type === 1
                                            ? "Percentage (Ex: VAT)"
                                            : item.type === 2
                                              ? "Fixed Value"
                                              : item.type === 3
                                                ? "Item Based"
                                                : ""}
                                        </td>
                                        <td>
                                          {item.safe_type === 1
                                            ? "VAT"
                                            : item.safe_type === 2
                                              ? "Stamp Duty"
                                              : item.safe_type === 3
                                                ? "Other"
                                                : ""}
                                        </td>
                                        <td>{item.stamp_tax || "-"}</td>
                                        <td>{item.exemption_reason}</td>
                                        <td>{item.fiscal_zone}</td>
                                        <td>
                                          {item.active_by_default === 1
                                            ? "Yes"
                                            : "No"}
                                        </td>

                                        <td>{item.vat_type || "-"}</td>
                                        <td className="d-flex">
                                          <Dropdown
                                            className="iconDropdown"
                                            onToggle={(isOpen) => {
                                              if (isOpen) {
                                                // This logic runs when the dropdown is opened
                                                const tableResponsive1 =
                                                  document.querySelector(
                                                    ".table-responsive1",
                                                  );
                                                if (window.innerWidth <= 767) {
                                                  if (tableResponsive1) {
                                                    tableResponsive1.style.overflowX =
                                                      "auto !important";
                                                    tableResponsive1.style.overflowY =
                                                      "auto !important";
                                                  }
                                                } else {
                                                  if (tableResponsive1) {
                                                    tableResponsive1.style.overflowX =
                                                      "inherit !important";
                                                    tableResponsive1.style.overflowY =
                                                      "inherit !important";
                                                  }
                                                }
                                              }
                                            }}
                                          >
                                            <Dropdown.Toggle
                                              variant="success"
                                              id="dropdown-basic"
                                              className="iconToggle"
                                            >
                                              <i className="bi bi-three-dots-vertical"></i>
                                            </Dropdown.Toggle>

                                            <Dropdown.Menu>
                                              <Dropdown.Item
                                                href="#/action-1"
                                                className="d-flex"
                                                onClick={() =>
                                                  navigate(
                                                    `/update-tax-fees/${item.id}`,
                                                    {
                                                      state: item,
                                                    },
                                                  )
                                                }
                                              >
                                                <div className="edit-btn">
                                                  <i className="bi bi-pencil"></i>
                                                </div>
                                                <span>{t("edit")}</span>
                                              </Dropdown.Item>
                                              <Dropdown.Item
                                                href="#/action-2"
                                                className="d-flex"
                                                onClick={(e) =>
                                                  onDeleteModalOpen(e, item)
                                                }
                                              >
                                                <div className="trash-btn">
                                                  <a className="delete-btn">
                                                    <i className="bi bi-trash3"></i>
                                                  </a>
                                                </div>
                                                <span>{t("delete")}</span>
                                              </Dropdown.Item>
                                            </Dropdown.Menu>
                                          </Dropdown>
                                        </td>
                                      </tr>
                                    </>
                                  );
                                })}
                              </tbody>
                              {taxMoloniList && taxMoloniList?.length === 0 && (
                                <tr>
                                  <td colSpan={7} className={`text-center`}>
                                    {t("no_record_found")}
                                  </td>
                                </tr>
                              )}
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="fuelCF">
            <div className="card-footer card-footer-part clearfix card-footer"
            style={{marginTop:"-26px"}}
            >
              <div className="pagination pagination-sm m-0 float-right">
                <ReactPaginate
                  previousLabel={<i className="bi bi-chevron-double-left"></i>}
                  nextLabel={<i className="bi bi-chevron-double-right"></i>}
                  breakLabel={"..."}
                  pageCount={Math.ceil(totalRecords / params.limit)}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={5}
                  onPageChange={(e) => handleParams(e, "pagination")}
                  forcePage={params.page - 1}
                  containerClassName={"pagination"}
                  activeClassName={"active"}
                  pageClassName={"page-item"}
                  pageLinkClassName={"page-link"}
                />
              </div>
            </div>
          </div>
        </section>
      </div>

      <Modal isOpen={delModal}>
        <ModalHeader>{t("delete_tax_and_fees")}</ModalHeader>
        <ModalBody>
          <p className={`mb-0`}>
            {t("Are you sure you want to delete this tax and fees")}
          </p>
        </ModalBody>
        <ModalFooter>
          <button
            type="button"
            className="btn btn-block btn-primary"
            disabled={isDelButtonLoad}
            onClick={onDeleteModalClose}
            style={{ width: "100px", marginTop: "10px" }}
          >
            {t("close")} <i className="bi bi-x-lg"></i>
          </button>

          {!isDelButtonLoad && (
            <button
              type="button"
              className="btn btn-block bg-red"
              style={{ width: "100px" }}
              onClick={onDestroyBank}
            >
              {t("delete")} <i className="bi bi-trash3"></i>
            </button>
          )}
          {isDelButtonLoad && (
            <button
              color="secondary"
              type={`button`}
              disabled={true}
              className={`btn-square`}
            >
              <i className="fa fa-circle-o-notch fa-spin"></i> {`Loading...`}
            </button>
          )}
        </ModalFooter>
      </Modal>

      <Modal isOpen={modifyModal}>
        <ModalHeader>{t("taxAndFees")}</ModalHeader>
        <Form method={`post`} onSubmit={handleSubmitForm}>
          <ModalBody>
            <div className="row">
              <div className="col-md-6">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my">
                    {t("name")}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <input
                        className="form-control input-search"
                        type="text"
                        value={taxMoloniData.name}
                        onChange={(e) => {
                          setTaxMoloniData({
                            ...taxMoloniData,
                            name: e.target.value,
                          });
                        }}
                        name={`name`}
                        maxLength={50}
                        placeholder="Name"
                      />
                    </div>
                    {errors.name && (
                      <span className="input-error">{errors.name}</span>
                    )}
                  </div>
                </FormGroup>
              </div>

              <div className="col-md-6">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my">
                    {t("value")}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <input
                        className="form-control input-search"
                        type="number"
                        value={taxMoloniData.value}
                        onChange={(e) => {
                          setTaxMoloniData({
                            ...taxMoloniData,
                            value: e.target.value,
                          });
                        }}
                        name={`value`}
                        maxLength={50}
                        placeholder="Value"
                      />
                    </div>
                    {errors.value && (
                      <span className="input-error">{errors.value}</span>
                    )}
                  </div>
                </FormGroup>
              </div>

              <div className="col-md-6">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my">
                    {t("type")}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <Select
                        className="my-select-v"
                        options={ConfigDB?.data?.typeList}
                        value={ConfigDB.data.typeList.find(
                          (item) => item.value == taxMoloniData.type,
                        )}
                        onChange={(selectedOption) => {
                          setTaxMoloniData({
                            ...taxMoloniData,
                            type: selectedOption ? selectedOption.value : "",
                          });
                        }}
                        isSearchable={true}
                        isClearable={true}
                        placeholder={"Select Type"}
                      />
                    </div>
                    {errors.type && (
                      <span className="input-error">{errors.type}</span>
                    )}
                  </div>
                </FormGroup>
              </div>

              <div className="col-md-6">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my">
                    {t("saft_type")}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <Select
                        className="my-select-v"
                        options={ConfigDB?.data?.saftTypeList}
                        value={ConfigDB.data.saftTypeList.find(
                          (item) => item.value == taxMoloniData.saft_type,
                        )}
                        onChange={(selectedOption) => {
                          setTaxMoloniData({
                            ...taxMoloniData,
                            saft_type: selectedOption
                              ? selectedOption.value
                              : "",
                          });
                        }}
                        isSearchable={true}
                        isClearable={true}
                        placeholder={"Select Saft type"}
                      />
                    </div>
                    {errors.saft_type && (
                      <span className="input-error">{errors.saft_type}</span>
                    )}
                  </div>
                </FormGroup>
              </div>

              {taxMoloniData?.saft_type === 1 && (
                <div className="col-md-6">
                  <FormGroup>
                    <Label className="col-form-label ml-2 Label-my">
                      {t("vat_type")}
                    </Label>
                    <div className="col-xl-12">
                      <div className="input-div">
                        <Select
                          className="my-select-v"
                          options={ConfigDB?.data?.vatTypeList}
                          value={ConfigDB.data.vatTypeList.find(
                            (item) => item.value == taxMoloniData.vat_type,
                          )}
                          onChange={(selectedOption) => {
                            setTaxMoloniData({
                              ...taxMoloniData,
                              vat_type: selectedOption
                                ? selectedOption.value
                                : "",
                            });
                          }}
                          isSearchable={true}
                          isClearable={true}
                          placeholder={"Select Saft type"}
                        />
                      </div>
                      {errors.vat_type && (
                        <span className="input-error">{errors.vat_type}</span>
                      )}
                    </div>
                  </FormGroup>
                </div>
              )}

              {taxMoloniData?.saft_type === 2 && (
                <div className="col-md-6">
                  <FormGroup>
                    <Label className="col-form-label ml-2 Label-my">
                      {t("stamp_tax")}
                    </Label>
                    <div className="col-xl-12">
                      <div className="input-div">
                        <input
                          className="form-control input-search"
                          type="text"
                          value={taxMoloniData.stamp_tax}
                          onChange={(e) => {
                            setTaxMoloniData({
                              ...taxMoloniData,
                              stamp_tax: e.target.value,
                            });
                          }}
                          name={`stamp_tax`}
                          maxLength={50}
                          placeholder="Stamp tax code"
                        />
                      </div>
                      {errors.stamp_tax && (
                        <span className="input-error">{errors.stamp_tax}</span>
                      )}
                    </div>
                  </FormGroup>
                </div>
              )}

              <div className="col-md-6">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my">
                    {t("fiscal_zone")}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <Select
                        className="my-select-v"
                        options={timeZoneList}
                        value={timeZoneList.find(
                          (item) => item.value == taxMoloniData.fiscal_zone,
                        )}
                        onChange={(selectedOption) => {
                          setTaxMoloniData({
                            ...taxMoloniData,
                            fiscal_zone: selectedOption
                              ? selectedOption.value
                              : "",
                          });
                        }}
                        isSearchable={true}
                        isClearable={true}
                        placeholder={"Select Fiscal Zone"}
                      />
                    </div>
                    {errors.fiscal_zone && (
                      <span className="input-error">{errors.fiscal_zone}</span>
                    )}
                  </div>
                </FormGroup>
              </div>

              <div className="col-md-6">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my">
                    {t("exemption_reason")}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <input
                        className="form-control input-search"
                        type="text"
                        value={taxMoloniData.exemption_reason}
                        onChange={(e) => {
                          setTaxMoloniData({
                            ...taxMoloniData,
                            exemption_reason: e.target.value,
                          });
                        }}
                        name={`exemption_reason`}
                        maxLength={50}
                        placeholder="Exemption Reason"
                      />
                    </div>
                    {errors.exemption_reason && (
                      <span className="input-error">
                        {errors.exemption_reason}
                      </span>
                    )}
                  </div>
                </FormGroup>
              </div>

              <div className="col-md-6">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my form-label form-label">
                    {t("active_by_default")}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <div className="form-check">
                        <input
                          className="my-checkbox-1 form-check-input"
                          type="checkbox"
                          checked={taxMoloniData.active_by_default === 1}
                          onChange={handleCheckboxDefaultChange}
                        />
                        <label className="form-check-label pl-6">
                          {t("active_by_default")}
                        </label>
                      </div>
                    </div>
                  </div>
                </FormGroup>
              </div>

              <div className="col-md-6"></div>
            </div>
          </ModalBody>
          <ModalFooter>
            <button
              type="button"
              className="btn btn-block btn-primary"
              disabled={isModifyButtonLoad}
              onClick={handleCloseModal}
              style={{ width: "100px", marginTop: "10px" }}
            >
              {t("close")} <i className="bi bi-x-lg"></i>
            </button>
            {!isModifyButtonLoad && (
              <button
                type="submit"
                className="btn btn-block btn-primary"
                style={{ width: "100px", marginTop: "10px" }}
              >
                {t("submit")} <i className="bi bi-check2"></i>
              </button>
            )}
            {isModifyButtonLoad && (
              <Button
                color="success"
                type={`button`}
                disabled={true}
                className={`btn-square`}
              >
                <i className="fa fa-circle-o-notch fa-spin"></i> {`Loading...`}
              </Button>
            )}
          </ModalFooter>
        </Form>
      </Modal>
    </div>
  );
};

export default TaxMoloni;
